<template>
<body>
  <div class="interview_head">
    <em>签证国家/地区：</em>
    <i>{{relative_city}}</i>
    <a @click="$pushByName('moreRegion',{init:2,route_id:route_id})" href="javascript:void(0);">
      <span>选择国家/地区>></span>
    </a>
  </div>
  <div class="interview_content">
    <div class="interview_table">
      <table v-if="system_config_vos.length > 0">
        <thead>
          <tr>
            <td class="interview_table_small">领区</td>
            <td>可预约面试时间段</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in system_config_vos"
            v-if="$dateUtil.normDateCompare(item.param_type_map.date2)"
          >
            <td>{{item.system_config.key_name}}</td>
            <td>{{item.param_type_map.date1}} 至 {{item.param_type_map.date2}}</td>
          </tr>
        </tbody>
      </table>
      <span style="font-size: 1.5em;" v-else>暂无信息</span>
    </div>
    <div class="interview_prompt">
      <p>
        <em>温馨提示：</em>以上是不同领区的预计可预约面试时间段，具体面试时间请咨询销售确认。
      </p>
    </div>
    <div class="interview_button">
      <a @click="close" href>
        <span>关闭</span>
      </a>
    </div>
  </div>
</body>
</template>
<script>
export default {
  name: "VisaInterviewDate",
  componentName: "VisaInterviewDate",
  data () {
    return {
      get_url: 'visa/interview_date_list/',
      route_id: 0,
      relative_city: '',
      system_config_vos: [],
    }
  },
  created () {
    this.route_id = this.$route.query.route_id
    this.relative_city = this.$route.query.relative_city
    if (this.relative_city) {
      this.$myGet(this.get_url + this.relative_city)
        .then(res => {
          this.system_config_vos = res.response.data.system_config_vos
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    } else {
      this.$msg('参数错误！', 'error')
    }
  },
  methods: {
    close () {
      window.close()
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/pages/html/three.css';
</style>



// WEBPACK FOOTER //
// src/pages/common/visaInterviewDate.vue